export function getPaths(menuItems) {
  const paths = [];
  function iteration(items) {
    for (const item of items) {
      if (item.url) {
        try {
          const url = new URL(item.url, 'http://dummybase.com');
          paths.push(url.pathname);
        } catch (e) {
        }
      }
      if (item.menus && Array.isArray(item.menus)) {
        iteration(item.menus);
      }
    }
  }
  iteration(menuItems);
  return paths;
}
